







































































































































import { Component, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import RichText from '@ivy/fts/comps/RichText.vue'
import SellDetail from '../../comps/sellDetail.vue'
import HeadPic from './snapshotPic.vue'
import ActDetail from './snapshotAct.vue'
@Component({
  components: {
    HeadPic,
    RichText,
    SellDetail,
    ActDetail,
  },
})
export default class OrderSnapshot extends Vue {
  show: boolean = false
  snapshotInfo: any
  tipText: string = `当前页面内容为订单快照，包含订单创建时的商品
                     描述和下单信息，双方产生交易争议时，该页面可
                     作为判断依据。`
  get hasActive() {
    return (
      this.snapshotInfo.activity &&
      Object.keys(this.snapshotInfo.activity).length > 0
    )
  }
  beforeCreate() {
    document.title = '交易快照'
  }
  async created() {
    let tid = this.$route.query.tid
    if (!tid) {
      return this.$Toast('订单不存在')
    }
    await env.init()
    if (!(await env.getIsLogin())) {
      return await env.login()
    }
    // 获取快照信息
    let { data: snapshotInfo } = await this.$axios.get(
      '/api/goods/order/snapshot/snapshot',
      {
        params: {
          tid: tid,
        },
      }
    )
    this.snapshotInfo = snapshotInfo
    this.show = true
  }
  viewGroupRule() {
    if (this.snapshotInfo.activity.rule_pic) {
      return this.$router.push(
        `/picPage?src=${this.snapshotInfo.activity.rule_pic}`
      )
    }
  }
}
